var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgPGeneralPlantHeatGen = function SvgPGeneralPlantHeatGen(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    x: "0px",
    y: "0px",
    viewBox: "0 0 684.2 480.2",
    xmlSpace: "preserve",
    enableBackground: "new 0 0 684.2 480.2"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M478.4,436.1h-0.7c-1.3,0-2.3-0.7-2.3-1.5l0,0c0,0.8-1,1.5-2.3,1.5h-0.7c-1.3,0-2.3-0.7-2.3-1.5l0,0 c0,0.8-1,1.5-2.3,1.5h-0.7c-1.3,0-2.3-0.7-2.3-1.5l0,0c0,0.8-1,1.5-2.3,1.5h-0.7c-1.3,0-2.3-0.7-2.3-1.5l0,0c0,0.8-1,1.5-2.3,1.5 h-0.7c-1.3,0-2.3-0.7-2.3-1.5l0,0c0,0.8-1,1.5-2.3,1.5h-0.7c-1.3,0-2.3-0.7-2.3-1.5l0,0c0,0.8-1,1.5-2.3,1.5h-0.7 c-1.3,0-2.3-0.7-2.3-1.5l0,0c0,0.8-1,1.5-2.3,1.5h-0.7c-1.3,0-2.3-0.7-2.3-1.5v-37.1c0-0.8,1-1.5,2.3-1.5h1.7v-2h12v2h7.7h0.7 c1.3,0,2.3,0.7,2.3,1.5l0,0c0-0.8,1-1.5,2.3-1.5h0.7c1.3,0,2.3,0.7,2.3,1.5l0,0c0-0.8,1-1.5,2.3-1.5h0.7c1.3,0,2.3,0.7,2.3,1.5l0,0 c0-0.8,1-1.5,2.3-1.5h0.7c1.3,0,2.3,0.7,2.3,1.5l0,0c0-0.8,1-1.5,2.3-1.5h0.7c1.3,0,2.3,0.7,2.3,1.5l0,0c0-0.8,1-1.5,2.3-1.5h0.7 c1.3,0,2.3,0.7,2.3,1.5l0,0c0-0.8,1-1.5,2.3-1.5h0.7c1.3,0,2.3,0.7,2.3,1.5l0,0c0-0.8,1-1.5,2.3-1.5h0.7c1.3,0,2.3,0.7,2.3,1.5 v37.1c0,0.8-1,1.5-2.3,1.5h-1.7v2h-12v-2H478.4L478.4,436.1z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M443,398.8h0.8c0.4,0,0.7,0.3,0.7,0.7v33.3c0,0.4-0.3,0.7-0.7,0.7H443c-0.4,0-0.7-0.3-0.7-0.7v-33.3 C442.4,399.1,442.7,398.8,443,398.8z",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.5,398.8h0.8c0.4,0,0.7,0.3,0.7,0.7v33.3c0,0.4-0.3,0.7-0.7,0.7h-0.8c-0.4,0-0.7-0.3-0.7-0.7v-33.3 C447.8,399.1,448.1,398.8,448.5,398.8z",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.8,398.8h0.8c0.4,0,0.7,0.3,0.7,0.7v33.3c0,0.4-0.3,0.7-0.7,0.7h-0.8c-0.4,0-0.7-0.3-0.7-0.7v-33.3 C453.1,399.1,453.5,398.8,453.8,398.8z",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459.2,398.8h0.8c0.4,0,0.7,0.3,0.7,0.7v33.3c0,0.4-0.3,0.7-0.7,0.7h-0.8c-0.4,0-0.7-0.3-0.7-0.7v-33.3 C458.5,399.1,458.8,398.8,459.2,398.8z",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M464.5,398.8h0.8c0.4,0,0.7,0.3,0.7,0.7v33.3c0,0.4-0.3,0.7-0.7,0.7h-0.8c-0.4,0-0.7-0.3-0.7-0.7v-33.3 C463.8,399.1,464.1,398.8,464.5,398.8z",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M469.8,398.8h0.8c0.4,0,0.7,0.3,0.7,0.7v33.3c0,0.4-0.3,0.7-0.7,0.7h-0.8c-0.4,0-0.7-0.3-0.7-0.7v-33.3 C469.1,399.1,469.4,398.8,469.8,398.8z",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M475.1,398.8h0.8c0.4,0,0.7,0.3,0.7,0.7v33.3c0,0.4-0.3,0.7-0.7,0.7h-0.8c-0.4,0-0.7-0.3-0.7-0.7v-33.3 C474.4,399.1,474.7,398.8,475.1,398.8z",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.5,398.8h0.8c0.4,0,0.7,0.3,0.7,0.7v33.3c0,0.4-0.3,0.7-0.7,0.7h-0.8c-0.4,0-0.7-0.3-0.7-0.7v-33.3 C479.8,399.1,480.1,398.8,480.5,398.8z",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M485.7,398.8h0.8c0.4,0,0.7,0.3,0.7,0.7v33.3c0,0.4-0.3,0.7-0.7,0.7h-0.8c-0.4,0-0.7-0.3-0.7-0.7v-33.3 C485,399.1,485.3,398.8,485.7,398.8z",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M491.1,398.8h0.8c0.4,0,0.7,0.3,0.7,0.7v33.3c0,0.4-0.3,0.7-0.7,0.7h-0.8c-0.4,0-0.7-0.3-0.7-0.7v-33.3 C490.4,399.1,490.7,398.8,491.1,398.8z",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M496.3,398.8h0.8c0.4,0,0.7,0.3,0.7,0.7v33.3c0,0.4-0.3,0.7-0.7,0.7h-0.8c-0.4,0-0.7-0.3-0.7-0.7v-33.3 C495.6,399.1,495.9,398.8,496.3,398.8z",
    fill: "#FFFFFF"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 508.1,
    y: 396.1,
    width: 64,
    height: 40,
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 510.1,
    y: 436.1,
    width: 8,
    height: 2,
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 562.1,
    y: 436.1,
    width: 8,
    height: 2,
    fill: "#C4C4C4"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M537.4,425.6c2.7-2.6,2.7-5.1,2.7-5.1s0,2.6,2.7,5.1c0.5,0.6,0.7,1.4,0.7,2.2c0,1.9-1.5,3.5-3.4,3.5 s-3.4-1.6-3.4-3.5C536.7,427,537,426.2,537.4,425.6z",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M544,430.9c0,0,5.8-2.9,5.8-8.1c0-4.1-2.7-7.7-4.2-9.8s-4.7-6.4-7-9c0,2.3-0.9,5.7-2.7,8.4 c-2.2,3.1-5.4,6.4-5.4,10.5c0,5.2,5.8,8.1,5.8,8.1",
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })))));
};
export default SvgPGeneralPlantHeatGen;